// extracted by mini-css-extract-plugin
module.exports = {"text":"KontaktOssKanalIngress_text__eN5pf"};